import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../api/api";
import { Wish } from "../api/urls";

export const fetchWishlist = createAsyncThunk("wishlist/fetch", async () => {
  const response = await api.get(Wish);
  return response.data;
});

const initialState=
  []

const WishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    addToWishlist(state, action) {
      const exists = state.find((item) => item.id === action.payload.id);
      if (!exists) state.push(action.payload);
    },
    removeFromWishlist(state, action) {
      return state.filter((item) => item.id !== action.payload);
    },
    setWishlist(state, action) {
      return action.payload;
    },
      setDefaultWishlistData:(state,action)=>{
return initialState
}

  },
});

export const { addToWishlist, removeFromWishlist, setWishlist,setDefaultWishlistData } =
  WishlistSlice.actions;
export default WishlistSlice.reducer;

